export const nameForGateway = (gateway: string) => {
  if (gateway === 'afterpay') return 'AfterPay';

  return 'Credit Card';
};
